import { HomeRounded, FileUploadIcon, UploadFileOutlined } from "@mui/icons-material";
import MuseumIcon from "@mui/icons-material/Museum";
import MemoryIcon from "@mui/icons-material/Memory";
import SummarizeIcon from "@mui/icons-material/Summarize";
import UploadFileRounded from "@mui/icons-material/UploadFileRounded";
import { Route } from "react-router-dom";
import DashboardNavCollapsableWithCustomNav from "components/Layout/DashboardNavCollapsableWithCustomNav/DashboardNavCollapsableWithCustomNav";
import { rootProtectedPath } from "data/authData";
import PosReco from "./POSReco.js";

export const posDashboardSideNavList = {
	HOME: { name: "Home", key: "HOME", display: true, icon: <HomeRounded /> },
	FILE_UPLOAD: { name: "File Upload", key: "FILE_UPLOAD", display: true, icon: <UploadFileRounded /> },
	STORE_MASTER: { name: "Store Master", key: "STORE_MASTER", display: true, icon: <MuseumIcon /> },
	JOBS: { name: "Jobs", key: "JOBS", display: true, icon: <MemoryIcon /> },
	REPORT: { name: "Report", key: "REPORT", display: true, icon: <SummarizeIcon /> },
};

export const posRecoBackgroundColor = "#F2F3F4";

// Recursive function to build routes
export const generatePosRoutesFromServiceTree = (service, rootPath) => {
	if (service?.types)
		return (
			<Route key={service.key} path={service.key}>
				{service.types &&
					Object.keys(service.types).map((childKey) => generatePosRoutesFromServiceTree(service.types[childKey], rootPath))}
			</Route>
		);
	else
		return (
			<Route
				key={service.key}
				path={service.key}
				element={
					<DashboardNavCollapsableWithCustomNav
						drawerList={posDashboardSideNavList}
						searchParamName="tab"
						navSpace={0}
						service={service}
						pathName={service.key}
						rootPath={rootPath}
						baseUrl={rootProtectedPath}
						mainService={"pos_reco"}
						sx={{ background: posRecoBackgroundColor }}
					/>
				}>
				<Route index element={<PosReco />} />
			</Route>
		);
};
